import React, { useState, useEffect, Fragment, useRef, useContext } from "react";
import "./index.css";
import alarm from "../../assets/alarm.svg";
import { Col, Dropdown, Row } from "react-bootstrap";
import {
  faBuilding,
  faCheck,
  faEye,
  faSyncAlt,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NotificacaoService from "../../services/NotificacaoService";
import Alert from "react-bootstrap/Alert";
import { trackPromise } from "react-promise-tracker";
import moment from "moment";
import formatDommus from "../../helpers/format";
import ReactTooltip from "react-tooltip";
import Swal from "sweetalert2";
import guService from "../../services/GuService";
import Chamado from "../../pages/Widgets/MeusChamados/Chamado";
import ModalDommus from "../Modal";
import { cpfMask } from "../InputTextMask";
import { PusherContext } from "../../contexts/PusherContext";
import notificationQueue from "../../helpers/notificationQueue";
import GuService from "../../services/GuService";

export default function Notificacoes({ history }) {
  const [listaNotificacoes, setListaNotificacoes] = useState([]);
  const [totalNotificacoes, setTotalNotificacoes] = useState(
    guService.getLocalState("totalNotificacoes") || 0
  );
  const [showDropDown, setShowDropDown] = useState(false);
  const [linhas, setLinhas] = useState([]);
  const [ringBell, setRingBell] = useState('');
  const ref = useRef(null);
  const pusher = useContext(PusherContext);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowDropDown(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [ref]);

  // Listener para evento de notificação de automação via Pusher
  useEffect(() => {
    if (pusher?.pusherState) {
      pusher.pusherState.bind('notificacao_automacao', function(data) {
        const idUsuarioLogado = guService.getLocalState("idUsuario");
        if (data?.id_usuario && String(data.id_usuario) !== String(idUsuarioLogado)) {
          return;
        }
        buscarNotificacoes({ silencioso: true }).then(() => {
          if (data?.texto) {
            notificationQueue.enqueue(data, emiteSwalAutomacao);
          }
        });
      });
    }
    return () => {
      if (pusher?.pusherState) {
        pusher.pusherState.unbind('notificacao_automacao');
      }
    };
  }, [pusher?.pusherState]);

  var today = new Date();
  today =
    String(today.getDate()).padStart(2, "0") +
    "/" +
    String(today.getMonth() + 1).padStart(2, "0") +
    "/" +
    today.getFullYear();

  useEffect(() => {
    geraLinhas();
  }, [listaNotificacoes]);

  useEffect(() => {
    const interval = setInterval(() => {
      buscarNotificacoes();
    }, 60000);
    buscarNotificacoes();
  }, []);


  function buscarNotificacoes(opcoes = {}) {
    const { silencioso = false } = opcoes;
    return NotificacaoService.buscarNotificacoes().then((response) => {
      let dados = response.data;
      let itens = [];
      setRingBell("");
      dados.notificacoes.forEach(function (valor, chave) {
        const item = {
          id_notificacao: valor.id_notificacao,
          id_ticket: valor.id_ticket,
          titulo: valor.tipo.descricao,
          texto: valor.tipo.texto,
          cor: valor.tipo.cor,
          criado_em: valor.criado_em,
          visto: valor.visto,
          notificado: valor.notificado,
          usuario: valor.usuario,
          criado_por: valor.criado_por,
          ticket_sigla: valor.ticket_sigla,
          ticket_tipo_nome: valor.nome_tipo_ticket,
          processo: valor.processo,
          empreendimento: valor.empreendimento,
          proponente: valor?.proponente,
          proponente_cpf: valor?.proponente_cpf ?? "",
          referencia: valor.referencia,
          id_referencia: valor.id_referencia
        };        
        if (!silencioso && valor.tipo.alert === '1' && valor.notificado === 0 && valor.visto === 0) {
          emiteAlerta(item);
        }        
        if (!silencioso && valor.tipo.toast === '1' && valor.notificado === 0 && valor.visto === 0) {
          emiteToast(item);
        }
        itens.push(item);
      });
      setListaNotificacoes(itens);
      atualizarNotificacoesPendentes(dados.total_notificacoes_nao_visto);      
    });
  }

  function emiteToast(dados) {
    beep();    
    const Toast = Swal.mixin({
      toast: true,
      position: "bottom-left",
      timer: 5000,
      timerProgressBar: true,
      confirmButtonText: "Abrir ticket",
      showDenyButton: true,
      denyButtonText: "Ignorar Notificação",
      didOpen: (toast) => {        
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    })

    let cpfProponente = dados?.proponente_cpf.length ? dados?.proponente_cpf : dados?.empreendimento?.cpf_cnpj_proponente;
    let nomeProponente = dados?.proponente.length ? dados?.proponente : dados.empreendimento.nome_proponente;
    let processo = dados?.processo.length ? dados?.processo : "Não vinculado";

    Toast.fire({
      icon: "info",
      title: dados.texto,
      html:`<div class="info-notificacao">
                <span style="margin-top: 0"><b> ${dados.ticket_sigla} - ${formatDommus.zeroPad(dados.id_ticket, 5)} | Processo nº: ${processo}</b></span>
                <span>${cpfMask(cpfProponente)} - ${nomeProponente}</span>
                ${dados?.empreendimento?.nome_empreendimento?.length ? `<span>${dados?.empreendimento?.nome_empreendimento ?? ""} | ${dados?.empreendimento?.descricao_unidade ?? ""} </span>` : ""}
                <span><b>Por:</b> ${dados.criado_por}</span> 
            </div>`,
      width: "500px",
      showCloseButton: true,
      closeButtonHtml: '<div>&#10006;</div>'
    }).then((result) => {
      if (result.isConfirmed) {        
        decrementarNotificacoes();
        abreTicket(dados.id_ticket, dados.id_notificacao);
      }
    });
    marcarNotificado(dados.id_notificacao);
  }

  function emiteSwalAutomacao(dados) {
    beep();
    marcarNotificado(dados.id_notificacao);
    const possuiProcesso = !!dados.id_processo;
    const isError = dados?.status === 'error';
    return Swal.fire({
      icon: isError ? 'error' : 'success',
      title: "Notificação de Automação",
      html: `
      <div style="text-align: center; padding: 5px 0;">
        <p style="
          font-size: ${isError ? '18px' : '14px'};
          color: ${isError ? '#d33' : '#555'};
          font-weight: ${isError ? '700' : '400'};
          margin-bottom: 12px;
          line-height: 1.5;
        ">
          ${dados.texto}
        </p>

        <span style="
          font-size: 13px;
          color: #183b64;
          font-weight: bold;
        ">
          Ticket: ${formatDommus.zeroPad(dados.id_ticket, 5)}
        </span>
      </div>
    `,
      width: "420px",
      confirmButtonText: possuiProcesso ? "Abrir Distrato" : "Abrir Ticket",
      confirmButtonColor: "#183b64",
      showDenyButton: possuiProcesso,
      denyButtonText: "Abrir Ticket",
      denyButtonColor: "#4c8dae",
      showCancelButton: possuiProcesso,
      cancelButtonText: "Ignorar",
      cancelButtonColor: "#868aa8",
      showCloseButton: true,
      customClass: {
        title: 'swal-titulo-notificacao-automacao',
      }
    }).then((result) => {
      if (result.isConfirmed) {
        decrementarNotificacoes();
        if (possuiProcesso) {
          abreDistrato(dados.id_processo, dados.id_notificacao);
        } else {
          abreTicket(dados.id_ticket);
        }
      } else if (result.isDenied) {
        decrementarNotificacoes();
        abreTicket(dados.id_ticket);
      }
    });
  }

  function marcarNotificado(idNotificacao){
    NotificacaoService.notificado(idNotificacao).then((resposne)=>{});
  }

  function emiteAlerta(dados) {
    beep();    
    Swal.fire({
      titleText: `${dados.ticket_sigla} - ${formatDommus.zeroPad(dados.id_ticket, 5)}`,
      text: dados.texto,
      icon: "warning",
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "Abrir ticket",
      cancelButtonText: "Ignorar notificação",
      customClass: {
        confirmButton: "btn btn-primary mr-3",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.isConfirmed) {
        decrementarNotificacoes();
        abreTicket(dados.id_ticket, dados.id_notificacao);
      }     
    });
    marcarNotificado(dados.id_notificacao);
  }


  function beep() {
    var snd = new Audio(
      "data:audio/mpeg;base64,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"
    );
    snd.play();
  }

  function buscarManualmente() {
    trackPromise(buscarNotificacoes(), "container-notificacao");
  }

  function goToSolicitacaoScreen(id){
    window.location.href = `/solicitacao-novo-acesso?id=${id}`;
  }


  function marcarLidaNaoLida(id) {
    trackPromise(
      NotificacaoService.marcarComoNaoLida(id).then((response) => {
        buscarNotificacoes();
      }),
      "container-notificacao"
    );
  }

  function atualizaNotificacoes(column) {
    NotificacaoService.atualizarNotificacoes(column).then((response) => {
      setTimeout(function () {
        buscarNotificacoes();
      }, 5000);
    });
  }

  function geraLinhas() {
    
    let linhasNotificacao = listaNotificacoes.map((item, index) => {
      return (
        <Fragment key={index}>
          <Dropdown.Item key={item.id_notificacao} id="row-notificacao" style={{borderLeft: `5px solid ${item?.cor}`}}>
            <div
              className="itemNotificacao"
              onClick={() => {
                if(item.referencia === 'T'){
                  abreTicket(item.id_ticket, item.id_notificacao)
                }else{
                  goToSolicitacaoScreen(item.id_referencia);
                }
               
              }}
            >
              <div className=" data-notificacoes-col ">                
                <Col className="col-8 dados-notificacao">
                  <Row>
                    <div
                      className="dataItemNotificacao"
                      style={{ fontWeight: item.visto == 0 ? "bold" : "", marginLeft: '15px'}}
                    >
                      <span>
                        {`${item?.ticket_sigla} - ${formatDommus.zeroPad(item?.id_ticket, 5)}`}
                      </span>
                      <span>{" | "}</span>
                      <span>
                        {`N° Processo: ${formatDommus.zeroPad(item?.processo, 5)}`}
                      </span>
                    </div>
                  </Row>
                  <div
                    className="conteudoItemNotificacao"
                    style={{ fontWeight: item.visto == 0 ? "bold" : "" }}
                  >
                    <div className="conteudo-item">
                      <span style={{fontSize: "0.85rem"}}>{item.texto}</span>
                      <div className="itens-processo">
                        <span>{item?.proponente}</span>
                        {item?.empreendimento && 
                          <div className="empreendimento-section">
                            <div className="d-flex -d-flex-row align-items-baseline" style={{gap: "5px"}}>
                              <FontAwesomeIcon icon={faBuilding}/>
                              <span>{item?.empreendimento?.nome_empreendimento}</span>
                            </div>
                            <span>{item?.empreendimento?.descricao_unidade}</span>
                          </div>
                        }
                      </div>                      
                    </div>
                  </div>
                </Col>
                <Col className="col-4 text-left align-items-center h-100">                  
                  <div
                    className="dataItemNotificacao"
                    style={{ fontWeight: item.visto == 0 ? "bold" : "" }}
                  >
                    <span>
                      {" "}
                      {moment(item.criado_em).format("DD/MM/YYYY HH:mm")}
                    </span>
                  </div>
                  <div
                    className="conteudoItemNotificacao"
                    style={{ fontWeight: item.visto == 0 ? "bold" : "" }}
                  >
                    <span>Por: {item.criado_por}</span>
                  </div>
                </Col>
              </div>
            </div>
            <ReactTooltip />
            <div
              className="statusNotificacao"
              onClick={() => marcarLidaNaoLida(item.id_notificacao)}
              data-tip={
                item.visto == 0 ? "Marcar como lida!" : "Marcar como não lida!"
              }
            >
              <span>
                <FontAwesomeIcon
                  style={{
                    color: item.visto == 1 ? "#1B80E4" : "#B1B6AF",
                    fontSize: "18px",
                  }}
                  size="sm"
                  icon={faCheck}
                />
              </span>
            </div>
          </Dropdown.Item>
        </Fragment>
      );
    });

    setLinhas(linhasNotificacao);
  }

  async function abreTicket(ticketId, id_notificacao) {
    marcarLidaNaoLida(id_notificacao);
    window.open(`${window.location.origin}/?idChamado=${btoa(String(ticketId))}`, '_blank', 'noreferrer');
  }

  async function abreDistrato(id_processo, id_notificacao) {
    marcarLidaNaoLida(id_notificacao);
    const urlVendas = GuService.getLocalState("linkVendas");
    window.open(
      urlVendas + 'index_ui.php?mgr=MQ==&ui=NTQ&id_processo=' + id_processo + '&aba=distrato',
      '_blank'
    );
  }

  function atualizarNotificacoesPendentes(count) {
    if(count > totalNotificacoes){
      setRingBell('shake-animation');
      beep();
    }
    setTotalNotificacoes(count);
    guService.setLocalState("totalNotificacoes", count);
  }

  function decrementarNotificacoes() {
    let notificacoesPendentes = Number(
      guService.getLocalState("totalNotificacoes")
    );

    notificacoesPendentes =
      notificacoesPendentes > 1 ? notificacoesPendentes - 1 : 0;

    setTotalNotificacoes(notificacoesPendentes);
    guService.setLocalState("totalNotificacoes", notificacoesPendentes);
  }

  return (
    <>
      <Dropdown show={showDropDown} ref={ref}>
        <Dropdown.Toggle
          onClick={() => {
            setShowDropDown(!showDropDown);
          }}
          className="notificacoes-dropdown"
        >
          <picture className={`picture-topo ${ringBell}`} data-tip data-for="notTip">
            <img src={alarm} alt="Ícone de sino" />
          </picture>
          <ReactTooltip id="notTip" place="top" effect="solid">
            Notificações
          </ReactTooltip>
          <div className="notificationIcon">{totalNotificacoes}</div>
        </Dropdown.Toggle>
        <Dropdown.Menu id="dropdown-menu-notificacoes">
          <div className="estilizacaoNotificacoes">
            <div className="titulo-notificacoes">
              <strong>Notificações -</strong>{" "}
              <span>
                <strong>{today}</strong>
              </span>{" "}
            </div>
            <div className="notificationsAction">
              <FontAwesomeIcon
                icon={faSyncAlt}
                onClick={() => buscarManualmente()}
                color="#868aa8"
                data-tip="Atualizar notificações"
              />
              {/* <FontAwesomeIcon icon={faCalendarAlt} color="#868aa8" data-tip="Filtrar por data" /> */}
              <FontAwesomeIcon
                icon={faEye}
                onClick={() => atualizaNotificacoes("visto")}
                color="#868aa8"
                data-tip="Marcar todas como lida"
              />
              <FontAwesomeIcon
                icon={faTimes}
                onClick={() => setShowDropDown(!showDropDown)}
                color="#868aa8"
                data-tip="Fechar"
              />
            </div>
          </div>
          <div className="listaNotificacoes">
            {linhas.length ? (
              linhas
            ) : (
              <>
                {" "}
                <Alert variant="warning">Nenhuma notificação pendente.</Alert>
              </>
            )}
          </div>
        </Dropdown.Menu>
      </Dropdown>      
    </>
  );
}
